import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../modules';
import { changeScreenMode, selectContent, toggleShowHistory } from '../../modules/editor';

import History from '../History/History';
import Sponsor from './Content/Sponsor';
import ContentsList from './ContentsList';

import produce from 'immer';
import history from '../../assets/images/icon/history.svg';
import selectIcon from '../../assets/images/icon/select.png';

import ReactTooltip from 'react-tooltip';
import ContentsAbtestDropdown from '../../components/Dropdown/ContentsAbtestDropdown';
import { TEXT_TEMPLATE } from '../../constants';

import { faDesktop, faMobileNotch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ContentContainer({ showBaseSidebar, changeSidebarStatus }) {
	const [screenMode, setScreenMode] = useState([
		{ name: 'desktop', width: '630px', icon: faDesktop, active: true },
		{ name: 'mobile', width: '315px', icon: faMobileNotch, active: false },
	]);
	const [canDrop, setCandrop] = useState(false);
	const [showSponsor, setShowSponsor] = useState(false);

	const dispatch = useDispatch();

	const contents = useSelector((state: RootState) => state.editor.contents);
	const container = useSelector((state: RootState) => state.editor.container);
	const backgroundFull = useSelector((state: RootState) => state.editor.container.backgroundFull);
	const contentsSaving = useSelector((state: RootState) => state.editor.ui.contentsSaving);
	const showHistory = useSelector((state: RootState) => state.editor.ui.showHistory);
	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	const totalSize = useSelector((state: RootState) => state.editor.service.totalSize);
	const account = useSelector((state: RootState) => state.auth.account);
	const service = useSelector((state: RootState) => state.auth.service);
	const emailType = useSelector((state: RootState) => state.editor.email.type);
	const emailSubType = useSelector((state: RootState) => state.editor.email.subType);
	const { templateId } = useSelector((state: RootState) => state.editor.email);

	const isContentsAbTest = emailType === 2 && emailSubType === 4;

	useEffect(() => {
		setShowSponsor(service.sponsor)
	}, [service])

	const cancelSelect = (e: any) => {
		if (selectedContentId === -1) {
			return;
		}
		dispatch(selectContent(-1));
	}

	const toggleScreenMode = (item: any) => {
		setScreenMode(produce(screenMode, (draft: any) => {
			draft.map((el: any) => {
				el.active = item.name === el.name;
			});
		}));
		dispatch(changeScreenMode(item.name));
	}

	const openHistory = () => {
		if (!service.isStandard) {
			window.parent.postMessage({ msg: 'openUpgradeGuideModal', guideType: 'versionHistory' }, '*');
			return;
		}

		dispatch(toggleShowHistory(true));
		window.parent.postMessage({ msg: 'dialogShow' }, '*');
		window.parent.postMessage({ msg: 'openHistoryModal' }, '*');
	}

	const closeHistory = () => {
		dispatch(toggleShowHistory(false));
		window.parent.postMessage({ msg: 'dialogHide' }, '*');
	}

	const onDrop = (candrop: boolean) => {
		setCandrop(candrop);
	}

	return (
		<div
			className={(templateId !== TEXT_TEMPLATE && showBaseSidebar) ? "editor-content" : "editor-content hided"}
			onClick={cancelSelect}
			style={{ background: backgroundFull.length === 0 ? '#fff' : backgroundFull }}
		>
			{(templateId !== TEXT_TEMPLATE) && (
				<button className={showBaseSidebar ? 'editor-sidebar-btn' : 'editor-sidebar-btn hided'} onClick={changeSidebarStatus}>
					<img src={selectIcon} />
				</button>
			)}
			<div className={(templateId !== TEXT_TEMPLATE) ? "content-status" : "content-status text-edit"}>
				{(templateId !== TEXT_TEMPLATE) ? (
					<>
						<div className={isContentsAbTest ? 'left-wrapper contents-abtest' : 'left-wrapper'}>
							{isContentsAbTest &&
								<div className='select-group'>
									<ContentsAbtestDropdown />
								</div>}
							{!service.isStandard && (
								<div className="file-limit">
									이미지 업로드 가능 용량 <em>{totalSize}</em>
								</div>
							)}
						</div>
						<div className="change-screen">
							{screenMode.map((item: any, index: number) => (
								<button
									key={index}
									className={item.active ? 'active' : ''}
									onClick={() => { toggleScreenMode(item); }}
								>
									<FontAwesomeIcon icon={item.icon} color={item.active ? 'white' : 'var(--gray-500'} />
								</button>
							))}
						</div>
					</>
				) : null}
				<div className="section">
					<div className="save">
						{
							contentsSaving ? '저장 중...' : '모든 변경 내용을 저장했습니다.'
						}
					</div>
					{
						(templateId !== TEXT_TEMPLATE) &&
						(<div className="history-btn">
							<button
								onClick={openHistory}
								data-tip='과거 기록 보기'
							>
								<img src={history} width='20' />
							</button>
							<ReactTooltip className='tooltip' place='bottom' effect='solid' offset={{ top: 3 }} />
						</div>)
					}
				</div>
			</div>
			{(templateId === TEXT_TEMPLATE) ? (
				<div className="editing-container text-edit">
					<div className='screen-mode-wrapper text-edit'>
						<ContentsList
							list={contents}
							container={container}
							onDrop={onDrop}
						/>
						{
							showSponsor && (
								<Sponsor plan={account?.billing?.plan} size="inline" />
							)
						}
					</div>
				</div>
			) : (
				<div className={"editing-container"}>
					<div
						className={screenMode.find((item: any) => item.active)?.name === 'mobile' ?
							'screen-mode-wrapper mobile' : 'screen-mode-wrapper'}
						style={{ width: screenMode.find((item) => { return item.active; })?.width }}
					>
						<ContentsList
							list={contents}
							container={container}
							onDrop={onDrop}
						/>
						{
							showSponsor && (
								<Sponsor plan={account?.billing?.plan} />
							)
						}
						{
							canDrop && (
								<div
									className={screenMode.find((item) => { return item.active; })?.name === 'desktop' ? 'add-content-candrop-guide' : 'add-content-candrop-guide mobile'}
								>
									<div className="line-left" ></div>
									<div className="line-right" ></div>
									<div className="line-top"></div>
									<div className="line-bottom" ></div>
								</div>
							)
						}
					</div>
				</div>
			)}
			{
				showHistory && (
					<History
						onClose={closeHistory}
					/>
				)
			}
		</div>
	);
}

export default ContentContainer;